export enum Path {
  HOME = "/home",

  //Auth
  LOGIN = "/login",
  LOGOUT = "/logout",

  //Curriculums
  CURRICULUMS = "/curriculums",
  CURRI_CREATE = "/curriculums/create",
  CURRICULUMS_DETAIL = "/curriculums/detail",
  // CURRICULUMS_ID = "/curriculums/:id",

  //User
  USERS = "/users",

  //Schedule
  SCHEDULES = "/schedules",
  SCHEDULES_SETTING = "/schedules/:sche",

  //Report
  REPORT = "/report",
  REPORT_CRRRI = "/report/:sche",
  REPORT_CRRRI_DOC3 = "/report/:sche/:curri",
  REPORT_DOC5 = "/report/:sche/:curri/:doc3",

  //Profile
  PROFILE = "/profile",

  //สำหรับสิทธิ์ user
  SENDDOC = "/senddoc",
  SENDDOC3 = "/senddoc3",
  DOC5 = "/doc5",

  FINDDOC = "/finddoc",
  MEMBER_INFO = "/info",
  MEMBER_REPORT = "/memberreport",

  SETTINGS = "/settings",

  DOC7 = "/doc7",

  DOWNLOADS = "/downloads",

  SUMMARY = "/summary",
  
  // ผลการทวนสอบ
  VERIFI= "/verification",
}
